"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CSelect = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _OutlinedInput = _interopRequireDefault(require("@mui/material/OutlinedInput"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _styles = require("@mui/material/styles");
var _labelConsts = require("../../constants/labelConsts");
var _stringConsts = require("../../constants/stringConsts");
const _excluded = ["className", "disabled", "intl", "setNone", "setHyphen", "items", "error", "helperText"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const StyledSelect = (0, _styles.styled)(_Select.default)({
  width: '100%'
});
const SelectContainer = (0, _styles.styled)(_FormControl.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    width: '100%',
    '&.Mui-error, & .MuiInputBase-root.Mui-error': {
      backgroundColor: (0, _styles.alpha)(theme.palette.error.main, 0.12),
      borderRadius: 4
    }
  };
});
const NoneSelectedEm = (0, _styles.styled)('em')(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    color: theme.palette.select.noneSelected
  };
});

/**
 * @classdesc セレクトボックス部品
 * @prop {string} value - 選択された値
 * @prop {boolean} [setNone=true] - 「選択してください」の表示有無
 * @prop {boolean} [setHyphen=false] - 「－」の表示有無
 * @prop {boolean} [disabled=false] - 非活性状態
 * @prop {fuction} onChange - 変更時のイベント<br/>
 * シグネチャ：(value:string):void
 * @prop {array} items - 選択肢のリスト
 * @prop {string} items.displayName - 選択肢の表示名
 * @prop {string|number} items.value - 選択肢の値
 * @prop {boolean} [error=false] - エラーステート
 * @prop {React.ReactNode} [helperText] - ヘルパーテキスト
 * @prop {string} [className] - ルート要素の className
 * @prop {object} [intl] - injectIntl により提供される国際化オブジェクト
 */
const CSelect = function (props) {
  const handleChange = event => {
    props.onChange(event.target.value);
  };
  const {
      className,
      disabled,
      intl,
      setNone = true,
      setHyphen,
      items,
      error,
      helperText
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const emptyString = setHyphen ? _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU : intl.formatMessage({
    id: _labelConsts.LABEL.CORE_PLEASE_SELECT
  });
  return /*#__PURE__*/_react.default.createElement(SelectContainer, {
    variant: "outlined",
    className: className,
    disabled: disabled,
    error: !!error
  }, /*#__PURE__*/_react.default.createElement(StyledSelect, _extends({}, rest, {
    displayEmpty: true,
    onChange: handleChange,
    input: /*#__PURE__*/_react.default.createElement(_OutlinedInput.default, null),
    error: !!error
  }), setNone && /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    value: ""
  }, /*#__PURE__*/_react.default.createElement(NoneSelectedEm, null, emptyString)), items.map(item => {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      value: item.value,
      key: item.value
    }, item.displayName);
  })), helperText && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    error: !!error
  }, helperText));
};
exports.CSelect = CSelect;
CSelect.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  setNone: _propTypes.default.bool,
  setHyphen: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    displayName: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })).isRequired,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.node
};
var _default = exports.default = /*#__PURE__*/_react.default.memo((0, _reactIntl.injectIntl)(CSelect));